import {
  GET_PLACES,
  GET_PLACES_DETAILS,
  GET_PLACES_REFRESH_MAP,
} from "./actions.type";

import {
  SET_PLACES,
  SET_PLACES_DETAILS,
  SET_PLACES_REFRESH_MAP,
} from "./mutations.type";

import { getCustomLayers } from "@/services/common/customLayers.service";

// place array will have objects per place each with following properties:
// data, name, uniqueId, mapped
const STATE = {
  places: [],
  details: {
    feature: null,
    title: null,
  },
  refreshMap: false,
};

const GETTERS = {
  places: (state) => state.places,
  details: (state) => state.details,
  refreshMap: (state) => state.refreshMap,
};

const ACTIONS = {
  async [GET_PLACES](context) {
    try {
      let RESULT = await getCustomLayers();
      context.commit("SET_PLACES", RESULT);
    } catch (error) {
      console.error("Error in GET_PLACES actions: " + error);
    }
  },
  [GET_PLACES_DETAILS](context, params) {
    context.commit(SET_PLACES_DETAILS, params);
  },
  [GET_PLACES_REFRESH_MAP](context, params) {
    context.commit(SET_PLACES_REFRESH_MAP, params);
  },
};

const MUTATIONS = {
  [SET_PLACES](state, data) {
    state.places = data;
  },
  [SET_PLACES_DETAILS](state, data) {
    state.details = data;
  },
  [SET_PLACES_REFRESH_MAP](state, data) {
    state.refreshMap = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
